import React, { useEffect, useContext, useState } from "react";
import { Button, Form, Row, Col, Card, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faCube,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import "./Summary.css";
import { Context } from "../../../../utils/context";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getData, postData } from "../../../../utils/api";
import OrderPlacedModal from "../OrderPlacedModal";
import ErrorModal from "../ErrorModal";
//import GST_modal from "../../../common/gst_modal/GST_modal";
import Green_Btn from "../../../common/green_btn/Green_Btn";
import { ClipLoader } from "react-spinners";
import { Code } from "lucide-react";
import View_All_Coupon_Code from "./view_All_Coupon_Code/View_All_Coupon_Code";

function Summary({
  prescription,
  user_id,
  setValue,
  watch,
  getValues,
  setOrderSummaryData,
  hoveredProduct,
  tax_type_id,
  gst_number,
  setOrderPlaced,
}) {
  console.log("Hovered Product:", hoveredProduct);
  const [paymentMethod, setPaymentMethod] = useState("1"); // default
  const [rewardData, setRewardData] = useState(false);
  const [rewardPoints, setRewardPoints] = useState(""); // NEW: points user wants to redeem
  const { toggleSidebar, IMG_URL } = useContext(Context);

  const [orderSummary, setOrderSummary] = useState();
  const [orderDetailsSummary, setOrderDetailsSummary] = useState();

  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowCoupon, setModalShowCoupon] = React.useState(false);
  const [CouponCode, setCouponCode] = useState("");
  const [Code, setCode] = useState("");
  const [CouponError, setCouponError] = useState("");
  const [Message, setMessage] = useState("");
  const [CouponApply, setCouponApply] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSuccessReward, setShowSuccessReward] = useState(false);

  const [rewardStatus, setRewardStatus] = useState(false);
  const [couponStatus, setCouponStatus] = useState(false);
  const calculateOrder = async (arr) => {
    // if (!user_id) {
    //   alert("Please Add User Details...!");
    //   return false;
    // }
    const res = await postData(`/admin/orders/calculate`, {
      products: arr,
      reward_status: rewardData,
      reward_points: rewardData ? Number(rewardPoints || 0) : 0, // NEW: send points to use
      code: CouponCode,
      user_id,
    });

    if (res?.success) {
      const summary = res?.data?.order_summary;

      await setOrderSummary(summary);
      setOrderSummaryData?.(summary);
      await setOrderDetailsSummary(res?.data?.order_Details_summary);
      console.log("Order Details Summary:", res.data.order_Details_summary);
      await setCouponError(res?.data?.order_summary?.message);
      if (
        res?.data?.order_summary?.coupon_applied &&
        CouponCode &&
        couponStatus
      ) {
        setMessage("Coupon applied successfully.");
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          setCouponStatus(false);
        }, 2000);
      } else if (
        res?.data?.order_summary?.reward_status &&
        rewardData &&
        rewardStatus
      ) {
        setMessage("Reward applied successfully.");
        setShowSuccessReward(true);
        setTimeout(() => {
          setShowSuccessReward(false);
          setRewardStatus(false);
        }, 2000);
      } else if (CouponCode) {
        setCouponCode("");
        setCode("");
        setCouponApply(false);
        setMessage(res?.data?.order_summary?.message);
        setShowError(true);
        setTimeout(() => {
          setShowError(false);
        }, 2000);
      }
    }
  };

  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();
  const [advancePayment, setAdvancePayment] = useState(0);
  const [DoctorName, setDoctorName] = useState("");

  const [loader, setLoder] = useState(false);

  const [orderId, setOrderId] = useState(null);

  const createOrder = async () => {
    
     if (!paymentMethod) {
    alert("Please Select Payment Method...!");
    return false;
  }
 if (!user_id) {
    alert("Please Add User Details...!");
    return false;
  }
  if (!orderDetailsSummary || orderDetailsSummary.length <= 0) {
    alert("Please add at least one product before placing the order.");
    return false;
  }
  setLoder(true);
    const finalData = new FormData();
    finalData.append("order_summary", JSON.stringify(orderSummary));
    finalData.append(
      "order_Details_summary",
      JSON.stringify(orderDetailsSummary),
    );
    finalData.append("payment_method_id", paymentMethod);
    finalData.append("user_id", user_id);

    finalData.append("advance_amount", advancePayment);
    finalData.append("gst_number", gst_number);
    finalData.append("tax_type_id", tax_type_id);

    finalData.append("doctor_name", DoctorName);

    // NEW: reward points redeemed for this order, so backend can debit the wallet
    finalData.append(
      "reward_points_used",
      rewardData ? Number(rewardPoints || 0) : 0,
    );

    const res = await postData(`/admin/orders`, finalData);

    if (res?.success) {
      console.log("Res", res);
      setOrderId(res?.data?.id);
      setMessage("Order Placed Successfully!");
      setShowSuccess(true);
      setShowModal(true);
      setLoder(false);
      setTimeout(() => {
        setMessage("");
        setShowModal(false);
        // setShowSuccess(false);
        // toggleSidebar();
        // navigate("/orders/all-orders");
      }, 3000);
    } else {
      setLoder(false);
      setMessage(res?.errors);
      await setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 3000);
    }
  };


  const downloadInvoice = async (order_id, isAdvance = false) => {
    setLoder(order_id);
    try {
      // console.log("isAdvance", isAdvance);
      const response = await postData("/common/masters/invoice-genarate", {
        order_id,
        isAdvance // <--- Pass it to the backend
      });

      if (!response?.data) {
        alert("Invoice not found");
        setLoder(false);
        return;
      }

      if (response?.success) {
        // console.log("1", response?.success);
        const fileUrl = `${IMG_URL}${response.data}`;
        // console.log("fileUrl", fileUrl);
        // 2️⃣ Fetch PDF silently (URL not visible to user)
        const fileResponse = await fetch(fileUrl);
        // console.log("fileResponse", fileResponse);
        const blob = await fileResponse.blob();
        // console.log("2", blob.type);
        if (blob.type !== "application/pdf") {
          alert("Invalid invoice file");
          setLoder(false);
          return;
        }

        // 3️⃣ Download file
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Invoice_${order_id}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        setLoder(false);
      }
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download invoice");
    }
  };

  const printAdvanceReceipt = () => {
    console.log("Triggering Advance Receipt Download...");
    // window.open(`/orders/advance-receipt/${orderId}`, "_blank");
  };

  const printTaxInvoice = () => {
    console.log("Triggering Tax Invoice Download...");
    // window.open(`/orders/tax-invoice/${orderId}`, "_blank");
  };
useEffect(() => {
  setOrderPlaced?.(showSuccess);
}, [showSuccess]);
  useEffect(() => {
    let timer;

    const subscription = watch((values) => {
      if (!values.products || !Array.isArray(values.products)) {
        return;
      }

      const arr = values.products
        .filter(
          (p) =>
            p?.product_details &&
            p?.product_details?.id
        )
        .map((p) => ({
          product_id: p.product_details.id,
          category_id: p.product_details.p_category_id,
          brand_id: p.product_details.brand_id,
          prescription_id:
            p.product_details.prescription_details?.prescription?.id,
          addon_id: p.product_details.addon_details?.id,
          lense_id: p.product_details.lens_details?.id,
          lense_category_id:
            p.product_details.lens_details?.p_category_id,
          lense_brand_id:
            p.product_details.lens_details?.brand_id,
          stock_lense_id:
            p.product_details.lens_details?.Stock?.id,
          barcode_no:
            p.product_details?.Stock?.barcode_no,
          quantity: 1,
          external_order: p.external_order ? 1 : 0,
          mrp: Number(p.product_details.mrp || 0),
          discount: Number(p.product_details.discount || 0),
          discount_amount: Number(
            p.product_details.discount_amount || 0
          ),
          tax_percentage: Number(
            p.product_details.tax_percentage || 0
          ),
          tax_amount: Number(
            p.product_details.tax_amount || 0
          ),
          price: Number(p.product_details.price || 0),
          base_amount: Number(p.product_details.base_amount || 0),
        }));


      if (arr.length === 0) {
        return;
      }


      clearTimeout(timer);


      timer = setTimeout(() => {
        calculateOrder(arr);
      }, 300);
    });

    return () => {
      clearTimeout(timer);
      subscription.unsubscribe();
    };
  }, [watch]);

  useEffect(() => {
    const values = getValues();

    if (!values.products || !Array.isArray(values.products)) {
      return;
    }

    const arr = values.products
      .filter(
        (p) =>
          p?.product_details &&
          p?.product_details?.id
      )
      .map((p) => ({
        product_id: p.product_details.id,
        category_id: p.product_details.p_category_id,
        brand_id: p.product_details.brand_id,
        prescription_id:
          p.product_details.prescription_details?.prescription?.id,
        addon_id: p.product_details.addon_details?.id,
        lense_id: p.product_details.lens_details?.id,
        stock_lense_id:
          p.product_details.lens_details?.Stock?.id,
        barcode_no:
          p.product_details?.Stock?.barcode_no,
        quantity: 1,
        external_order: p.external_order ? 1 : 0,
        mrp: Number(p.product_details.mrp || 0),
        discount: Number(p.product_details.discount || 0),
        discount_amount: Number(
          p.product_details.discount_amount || 0
        ),
        tax_percentage: Number(
          p.product_details.tax_percentage || 0
        ),
        tax_amount: Number(
          p.product_details.tax_amount || 0
        ),
        price: Number(p.product_details.price || 0),
        base_amount: Number(p.product_details.base_amount || 0),
      }));

    if (arr.length === 0) {
      return;
    }

    calculateOrder(arr);
  }, [rewardData, CouponApply]); // recalculates on Apply/Remove click only 

  const [userWallet, setUserWallet] = useState(false);

  const fetchUserWalletData = async () => {
    if (!user_id) return;
    const res = await getData(`/admin/wallet/${user_id}`);
    if (res?.success) {
      setUserWallet(res.data);
    }
  };

  useEffect(() => {
    fetchUserWalletData();
  }, [user_id]);

  const amount = parseFloat(userWallet?.amount || 0);


  const appliedPoints = rewardData ? Number(rewardPoints || 0) : 0;


  const remainingRewardBalance = Math.max(amount - appliedPoints, 0);

  useEffect(() => {
  const newTotal = Number(orderSummary?.total_amount || 0);
  setAdvancePayment((prev) => {
    if (prev === "" || prev === 0) return prev;
    return Number(prev) > newTotal ? newTotal : prev;
  });
}, [orderSummary?.total_amount]);
const hasProduct = (orderDetailsSummary?.length || 0) > 0;
  const grandTotal = Number(orderSummary?.total_amount || 0);
  const remainingAmount = Math.max(grandTotal - Number(advancePayment || 0), 0);
  const handleApplyCoupon = (code) => {
    setCode(code);
    setCouponCode(code);
    if (!code.trim()) {
      setCouponError("Coupon code is required");
      return;
    }
    setModalShowCoupon(false);
    setCouponStatus(true);
    setCouponError("");
    setCouponApply(true);
  };

  // NEW: handle reward Apply/Remove click, with validation on the entered points
  const handleRewardToggle = () => {
    if (!rewardData) {
      if (!rewardPoints || Number(rewardPoints) <= 0) {
        setCouponError("Please enter reward points to use");
        return;
      }
      if (Number(rewardPoints) > amount) {
        setCouponError("Points exceed available balance");
        return;
      }
    } else {
      // removing reward - reset the input
      setRewardPoints("");
    }
    setCouponError("");
    setRewardData(!rewardData);
    setRewardStatus(true);
  };

  return (
    <>
      {/* Reward Points + Coupon Code section — kept in its own separate div, above the Summary */}
      <div className="reward-coupon-section">
        <Row className="align-items-center g-2 reward-coupon-row">
          <Col xs="auto" className="d-flex align-items-center">
            <span className="me-2">
              {rewardData ? "Reward Points Remaining" : "Reward Points"}
            </span>
            <Col xs="auto" className="d-flex align-items-center">
              <span className="me-2">:</span>
              <Badge bg="info">₹ {Math.round(remainingRewardBalance)}</Badge>
            </Col>

            {/* NEW: shows how many points are currently applied to this order */}
            {rewardData && (
              <Badge bg="success" className="mx-2">
                Used ₹ {Math.round(appliedPoints)}
              </Badge>
            )}

            {/* NEW: input box for the number of points the user wants to redeem */}
            <Form.Control
              type="number"
              min="0"
              max={amount}
              value={rewardPoints}
              disabled={rewardData || showSuccess}
              onChange={(e) => {
                const raw = e.target.value;
                if (raw === "") {
                  setRewardPoints("");
                  return;
                }
                const num = Number(raw);
                if (!isNaN(num) && num >= 0 && num <= amount) {
                  setRewardPoints(num);
                }
              }}
              placeholder="Points"
              size="sm"
              style={{ width: "90px" }}
              className="mx-2"
            />

            <Badge
  bg={rewardData ? "danger" : "secondary"}
  onClick={showSuccess ? undefined : handleRewardToggle}
  style={{
    cursor: showSuccess ? "not-allowed" : "pointer",
    opacity: showSuccess ? 0.6 : 1,
  }}
>
  {rewardData ? "Remove" : "Apply"}
</Badge>
          </Col>

          <Col xs="auto" className="d-flex align-items-center">
            <span className="me-2">Coupon Code</span>
            <Form.Control
              type="text"
              value={Code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Code"
              size="sm"
              style={{ width: "150px" }}
              disabled={showSuccess}
            />
          </Col>

          <Col xs="auto">
            {orderSummary?.coupon_applied ? (
              <Button
                size="sm"
                onClick={() => setCouponError("Coupon Remove First")}
              >
                View All Coupon
              </Button>
            ) : (
              <Button size="sm" disabled={showSuccess}onClick={() => setModalShowCoupon(true)}>
                View All Coupon
              </Button>
            )}
          </Col>

          <Col xs="auto">
            {orderSummary?.coupon_applied ? (
              <Button
                size="sm"
                onClick={() => {
                  setCouponApply(false);
                  setCouponCode("");
                  setCode("");
                }}
              >
                Remove
              </Button>
            ) : (
              <Button size="sm" disabled={showSuccess} onClick={() => handleApplyCoupon(Code)}>
                Apply
              </Button>
            )}
          </Col>

          {CouponError && (
            <Col xs="auto">
              <div style={{ color: "red" }}>{CouponError}</div>
            </Col>
          )}
        </Row>
      </div>

      <section className="summary-container">
        <h4 className="summary-title">Summary</h4>

        {/*  {hoveredProduct && (
          <div className="text-center mb-4">
            <img
              src={
                IMG_URL +
                (
                  hoveredProduct.product_image ||
                  hoveredProduct.image ||
                  hoveredProduct.image_url ||
                  ""
                )
              }
              alt={hoveredProduct.product_name}
              style={{
                width: "180px",
                height: "180px",
                objectFit: "contain",
              }}
            />
            <h5 className="mt-2">{hoveredProduct.product_name}</h5>
          </div>
        )}*/}

        <Row>
          {/* LEFT: Calculation / Grand Total */}
          <Col md={6} lg={6} className="mb-3">
            <Card className="summary-card shadow-sm p-0 h-100">
              <Card.Body>
                <Row className="summary-row">
                  <Col>Total MRP</Col> {/*Gross Price*/}
                  <Col className="text-end">
                    ₹ {Math.round(orderSummary?.total_mrp || 0)}
                  </Col>
                </Row>

                <Row className="summary-row">
                  <Col>Tax amount</Col>
                  <Col className="text-end">
                    ₹ {Math.round(orderSummary?.total_tax  || 0)}
                  </Col>
                </Row>

                <Row className="summary-row">
                  <Col>Discount</Col> {/*Product Discount*/}
                  <Col className="text-end">
                    ₹ {Math.round(orderSummary?.total_discount || 0)}
                  </Col>
                </Row>
                {/*<Row className="summary-row">
                  <Col>Lens MRP</Col>
                  <Col className="text-end">
                    ₹ {Number(orderSummary?.total_lense_mrp).toFixed(2)}
                  </Col>
                </Row>
                <Row className="summary-row">
                  <Col>Lens Discount</Col>
                  <Col className="text-end">
                    ₹ {Number(orderSummary?.total_lense_discount).toFixed(2)}
                  </Col>
                </Row>*/}
                {/* <Row className="summary-row">
                  <Col>Addon Price</Col>
                  <Col className="text-end">
                    ₹ {Number(orderSummary?.total_addon_price).toFixed(2)}
                  </Col>
                </Row> */}

                {/*<Row className="summary-row">
                  <Col>Product Tax</Col>
                  <Col className="text-end">
                    ₹ {Number(orderSummary?.total_tax).toFixed(2)}
                  </Col>
                </Row>*/}
                {/* <Row className="summary-row">
                    <Col>Lens Tax</Col>
                    <Col className="text-end">
                      ₹ {Number(orderSummary?.total_lense_tax).toFixed(2)}
                    </Col>
                  </Row>
                  */}

                <Row className="summary-row">
                  <Col>Coupon </Col> {/*Coupon Discount*/}
                  <Col className="text-end text-danger">
                    - ₹ {Math.round(orderSummary?.total_coupon_discount || 0)}
                  </Col>
                </Row>

                {/*<Row className="summary-row">
                  <Col>Offer Discount</Col>
                  <Col className="text-end text-danger">
                    - ₹ {Number(orderSummary?.total_offer_discount).toFixed(2)}
                  </Col>
                </Row>*/}

                <Row className="summary-row">
                  <Col>Rewards</Col> {/*Reward Discount*/}
                  <Col className="text-end text-danger">
                    - ₹ {Math.round(orderSummary?.reward_discount || 0)}
                  </Col>
                </Row>

                {/* <Row className="summary-row">
                  <Col>Shipping</Col>
                  <Col className="text-end text-danger">
                    ₹ {Number(orderSummary?.total_delivery_charges).toFixed(2)}
                  </Col>
                </Row> */}

                <hr />

                {/*<Row className="summary-row align-items-center">
                  <Col>GST Number</Col>
                  <Col className="text-end text-danger">
                    <div className="row-divider">
                      <div className="qty_div">
                        <Green_Btn
                          onClick={() => setModalShow(true)}
                          btn_name="GST Number"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                */}

                <Row className="summary-row total-row">
                  <Col>Total amount</Col> {/*Grand Total*/}
                  <Col className="text-end fw-bold fs-6 text-success">
                    ₹ {Math.round(orderSummary?.total_amount || 0)}
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer className="text-muted text-center bg-transparent border-0 pb-3" style={{ fontSize: '0.8rem' }}>
                (Total MRP is inclusive of all tax)
              </Card.Footer>
            </Card>
          </Col>

          {/* RIGHT: Payment Method through Place Order */}
          <Col md={6} lg={6} className="mb-3">
            <Card className="shadow-sm h-100">
              <Card.Body>
                <h6 className="fw-bold mb-3">Select Payment Method</h6>
                <Form>
                  <div className="payment-method-row">
                    <div className="payment-group">
                      <Form.Check
                        type="radio"
                        id="cash"
                        label="💵 Cash"
                        value="1"
                        name="paymentMethod"
                        checked={paymentMethod === "1"}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="payment-radio"
                        disabled={showSuccess}
                      />
                    </div>

                    <div className="payment-group payment-group-online">
                      <span className="payment-online-label">Online:</span>

                      <Form.Check
                        type="radio"
                        id="card"
                        label={
                          <span className="d-inline-flex align-items-center gap-1">
                            💳 Card
                          </span>
                        }
                        value="3"
                        name="paymentMethod"
                        checked={paymentMethod === "3"}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="payment-radio"
                        disabled={showSuccess}  
                      />

                      <Form.Check
                        type="radio"
                        id="qr"
                        label="🔳 QR"
                        value="4"
                        name="paymentMethod"
                        checked={paymentMethod === "4"}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="payment-radio"
                        disabled={showSuccess}
                      />
                    </div>
                  </div>
                </Form>

                <Row className="summary-row align-items-center mt-3">
                  <Col>Advance Payment</Col>
                  <Col className="text-end">
                    <Form.Control
                      type="number"
                      min="0"
                      max={grandTotal}
                      disabled={showSuccess}
                      value={advancePayment === 0 ? "" : advancePayment}
                      onChange={(e) => {
                        const raw = e.target.value;
                        if (raw === "") {
                          setAdvancePayment("");
                          return;
                        }
                        const value = Number(raw);
                        if (!isNaN(value) && value > 0 && value <= grandTotal) {
                          setAdvancePayment(value);
                        }
                      }}
                      placeholder="0.00"
                      size="sm"
                    />
                  </Col>
                </Row>

                <Row className="summary-row">
                  <Col>Remaining Amount</Col>
                  <Col className="text-end fw-bold text-warning">
                    ₹ {Math.round(remainingAmount)}
                  </Col>
                </Row>

                <Row className="summary-row align-items-center">
                  <Col>Doctor Name</Col>
                  <Col className="text-end">
                    <Form.Control
                      type="text"
                      value={DoctorName}
                      disabled={showSuccess}
                      onChange={(e) => setDoctorName(e.target.value)}
                      placeholder="Doctor Name"
                      size="sm"
                    />
                  </Col>
                </Row>

                {loader ? (
                  <div className="text-center">
                    <ClipLoader />
                  </div>
                ) : (
                  <>
                   {!showSuccess ? (
  <>
    <Button
      className="place-order-btn w-100 mt-3"
      onClick={createOrder}
      disabled={!hasProduct || !user_id}
    >
      <FontAwesomeIcon icon={faCube} className="me-2" />
      Place Order
    </Button>
    {!hasProduct && (
      <p className="text-danger small mb-0 mt-1 text-center">
        Please add at least one product to place the order
      </p>
    )}
    {hasProduct && !user_id && (
      <p className="text-danger small mb-0 mt-1 text-center">
        Please add user details to place the order
      </p>
    )}
  </>
) : (
  // ...unchanged success branch
                      <>
                        <Row className="mt-3 mb-2">
                          <Col xs={6} className="pe-1">
                            <Button
                              variant="outline-secondary"
                              className="w-100 shadow-sm"
                              size="sm"
                              disabled={
                                !advancePayment ||
                                Number(advancePayment) <= 0 ||
                                (grandTotal > 0 && remainingAmount === 0)
                              }
                              onClick={() => downloadInvoice(orderId, true)}
                            >
                              Print Advance Receipt
                            </Button>
                          </Col>



                          <Col xs={6} className="ps-1">
                            <Button
                              variant="outline-primary"
                              className="w-100 shadow-sm"
                              size="sm"
                              disabled={Number(advancePayment) > 0 && remainingAmount > 0}
                              onClick={() => downloadInvoice(orderId, false)}
                            >
                              Print Tax Invoice
                            </Button>
                          </Col>
                        </Row>

                        <Button
                          variant="success"
                          className="w-100"
                          onClick={() => {
                            setShowSuccess(false);
                            toggleSidebar();
                            navigate("/orders/all-orders");
                          }}
                        >
                          Done! Go to Orders
                        </Button>
                      </>
                    )}
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </section>
      <OrderPlacedModal
        show={showSuccessReward}
        setShowSuccess={setShowSuccessReward}
        message={Message}
      />
      <ErrorModal
        show={showError}
        setShowSuccess={setShowError}
        message={Message}
      />
      {/*
      <GST_modal
        GSTNumber={GSTNumber}
        setGSTNumber={setGSTNumber}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
*/}

      <View_All_Coupon_Code
        setCouponCode={setCouponCode}
        handleApplyCoupon={handleApplyCoupon}
        // onApply={(code) => {
        //   setCouponCode(code);
        //   // handleSubmit(onSubmit)();
        //   setModalShow(false); // hit apply API
        // }}
        show={modalShowCoupon}
        onHide={() => setModalShowCoupon(false)}
      />
    </>
  );
}

export default Summary;